export default __webpack_public_path__ + "static/media/card-visa.7c255b6b.svg";